import DOMPurify from "dompurify";

/**
 * Renders an article body that may be either:
 *  - Legacy plain text (all articles created before Admin self-service
 *    publishing existed) — paragraph breaks only, rendered exactly as
 *    before via whitespace-pre-wrap. Zero visual change.
 *  - Real HTML (anything authored/saved through the new Admin WYSIWYG
 *    editor) — sanitised then rendered with Tailwind Typography (`prose`)
 *    so headings, bold/italic, lists, links and quotes all display
 *    properly on the public page.
 *
 * Detecting which one we have means existing articles never need any
 * data migration — only content saved through the new editor ever
 * becomes real HTML.
 */
const HTML_TAG_RE = /<[a-z][\s\S]*>/i;

export function isHtmlBody(body) {
  return typeof body === "string" && HTML_TAG_RE.test(body);
}

export default function ArticleBody({ body, testId }) {
  if (isHtmlBody(body)) {
    return (
      <div
        className="prose prose-lg max-w-none prose-headings:font-display prose-a:text-teal prose-blockquote:border-teal"
        data-testid={testId}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(body) }}
      />
    );
  }
  return (
    <div className="whitespace-pre-wrap leading-relaxed" data-testid={testId}>
      {body}
    </div>
  );
}
